const STORAGE_KEY = "flip_pending_paystack_payment";
const MAX_PENDING_AGE_MS = 24 * 60 * 60 * 1000;

const isBrowser = typeof window !== "undefined";

export function savePendingPaystackPayment(payload) {
  if (!isBrowser) {
    return;
  }

  window.localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      ...payload,
      createdAt: Date.now()
    })
  );
}

export function getPendingPaystackPayment() {
  if (!isBrowser) {
    return null;
  }

  const rawValue = window.localStorage.getItem(STORAGE_KEY);

  if (!rawValue) {
    return null;
  }

  try {
    const parsedValue = JSON.parse(rawValue);
    const createdAt = Number(parsedValue?.createdAt || 0);

    if (!createdAt || Date.now() - createdAt > MAX_PENDING_AGE_MS) {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return parsedValue;
  } catch (_error) {
    window.localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearPendingPaystackPayment(reference) {
  if (!isBrowser) {
    return;
  }

  if (!reference) {
    window.localStorage.removeItem(STORAGE_KEY);
    return;
  }

  const existingPayment = getPendingPaystackPayment();

  if (existingPayment?.reference === reference) {
    window.localStorage.removeItem(STORAGE_KEY);
  }
}
